import React from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles } from '@material-ui/core';
import colors from '../modules/colors';

const useStyles = makeStyles((theme) => ({
  message: {
    backgroundColor: `${colors.taupe} !important`,
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: 8,
  },
}));

function MessageBox({ children }) {
  const classes = useStyles();
  return (
    <Box className={classes.message}>
      {children}
    </Box>
  );
}

MessageBox.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node), // as you can render an array of elements
    PropTypes.element, // for a single component/element
  ]).isRequired,
};

export default MessageBox;
